import {RoleService} from './../shared/role.service';
import {Observable} from 'rxjs';
import {UsuariosListComponent} from './usuarios-list.component';
import {UserService} from './../shared/user.service';
import {User} from './../shared/user.model';
import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import * as myGlobals from './../global';
import {Role} from '../shared/role.model';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-usuario',
  templateUrl: './edit-usuario.component.html',
  styleUrls: ['./edit-usuario.component.sass']
})
export class EditUsuarioComponent implements OnInit, AfterViewInit, OnDestroy {
  users: User[] = [];
  errorMessage = '';
  user: User;

  roleSelected: number;
  roleList: Observable<Role[]> = this.roleService.allRoles();

  constructor(public service: UserService, private parent: UsuariosListComponent, private roleService: RoleService) {
  }

  ngAfterViewInit() {
    $('a[rel=usuarios]').addClass('selected');
  }

  ngOnInit() {
    console.log('EditUsuarioComponent: Init: id: ', this.parent.editnumber);
    this.getUser(this.parent.editnumber);
    // this.roleSelected = this.user.roleId;
  }

  getUser(id: number) {
    this.service.getUser(id).subscribe(user => (this.user = user), error => (this.errorMessage = error as any));
    console.log("EditUsuarioComponent: getUser: roleId: ", this.user);
    // this.roleSelected = this.user.roleId;
  }

  edit(item): boolean {
    console.log('EditUsuarioComponent: edit: id: ' + item.parent.editnumber);
    // id: number;
    // email: string;
    // lastname1: string;
    // lastname2: string;
    // name: string;
    // password: string;
    // roleId: number;
    // status: number;
    /* var formData = {
      name: $("input[name=name]").val(),
      lastname1: $("input[lastname1=lastname1]").val(),
      lastname2: $("input[lastname2=lastname2]").val(),
      roleId: $("#roleId option:selected").val(),
      status: $("#status option:selected").val(),
      email: $("input[email=email]").val()
    }; */
    const formData = {
      email: this.user.email,
      lastname1: this.user.lastname1,
      lastname2: this.user.lastname2,
      name: this.user.name,
      password: this.user.password,
      roleId: this.user.roleId,
      status: this.user.status
    };
    console.log('EditUsuarioComponent: edit: password: ', this.user.password);
    console.log('EditUsuarioComponent: edit: formData: ', JSON.stringify(formData));
    // console.log("EditUsuarioComponent: edit: user: ", JSON.stringify(this.user));

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/user/' + item.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function (response) {
      console.log('EditUsuarioComponent: edit: Delete successfully!!');
      parentRef.showUsuarios = true;
      parentRef.showAddUsuario = false;
      parentRef.showEditUsuario = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el usuario: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  cancelUsuario(): void {
    this.parent.showUsuarios = true;
    this.parent.showAddUsuario = false;
    this.parent.showEditUsuario = false;
  }

  ngOnDestroy() {
    $('a[rel=usuarios]').removeClass('selected');
  }
}
